<template>
	<div class="p-x-20 p-y-20 border-bottom">
		<div class="f-bold f-16 f-c-black">
			Input Date - SOInputDate
		</div>
		<SOInputDate
			v-if="!rerender"
			:placeholder="input.date.placeholder"
			:title="input.date.title"
			:value="input.date.value"
			:id="input.date.id"
			:max-date="input.date.maxDate"
			:min-date="input.date.minDate"
			@get-date="(val) => { input.date.value = val }"
		/>
		<div class="p-t-12">
			<div class="f-semi f-14 f-c-black">Attribut v-bind:</div>
			<div class="f-regular f-12 f-c-midgrey">
				<div v-for="(val, key) in input.date" :key="`input-date-${key}`" class="p-d-4">
					<div><b>v-bind:{{ key }}</b></div>
					<input v-if="typeof val !== 'boolean'" type="text" v-model="input.date[key]">
					<input v-if="typeof val === 'boolean'" type="checkbox" v-model="input.date[key]">
				</div>
			</div>
		</div>
		<div class="p-t-12">
			<div class="f-semi f-14 f-c-black">Attribut v-on:</div>
			<div class="f-reguler f-12 f-c-midgrey">
				<b>v-on:get-date</b>
				<pre>(val) => { input.date.value = val }</pre>
			</div>
		</div>
	</div>
</template>

<script>
import SOInputDate from "@/so-components/global/input/SOInputDate";

export default {
	name: "PlaygroundInputDate",
	components: {
		SOInputDate,
	},
	watch: {
		"input.date.maxDate": {
			handler: function () {
				this.doRerender()
			},
			deep: true,
		},
		"input.date.minDate": {
			handler: function () {
				this.doRerender()
			},
			deep: true,
		}
	},
	data() {
		return {
			rerender: false,
			input: {
				date: {
					placeholder: "Placeholder Input Date",
					title: "Title Input Date",
					value: this.$moment().format("YYYY-MM-DD"),
					id: "input-date",
					maxDate: "",
					minDate: "",
				}
			}
		}
	},
	methods: {
		doRerender() {
			this.rerender = true
			setTimeout(() => {
				this.rerender = false
			}, 10)
		}
	}
}
</script>